import { FormGroup, FormControl, Validators } from "@angular/forms";


export var GipAdmDocEnvForm = new FormGroup({
  ID: new FormControl(),
  CONTRACT_ID: new FormControl(),
  SERVICE: new FormControl(),
  CATEGORY: new FormControl('', Validators.maxLength(50)),
  //OBJECTID: new FormControl(),
  REMARK: new FormControl('', Validators.maxLength(50)),
  CONTENTTYPE: new FormControl('', Validators.maxLength(255)),
  USERNAME: new FormControl('', Validators.maxLength(255)),
  VALIDFROM: new FormControl('', Validators.required),
  VALIDTO: new FormControl('', Validators.required),
  PATH: new FormControl('', Validators.maxLength(511)),
  HINT: new FormControl(),
});

export class GipAdmDocEnvModel {
  public ID: string;
  public CONTRACT_ID: string;
  public SERVICE: string;
  public CATEGORY: string;
  public REMARK: string;
  public CONTENTTYPE: string;
  public USERNAME: string;
  public VALIDFROM: string;
  public VALIDTO: string;
  public PATH: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CONTRACT_ID = formModel.controls["CONTRACT_ID"].value;
    this.SERVICE = formModel.controls["SERVICE"].value;
    this.CATEGORY = formModel.controls["CATEGORY"].value;
    this.REMARK = formModel.controls["REMARK"].value;
    this.CONTENTTYPE = formModel.controls["CONTENTTYPE"].value;
    this.USERNAME = formModel.controls["USERNAME"].value;
    this.VALIDFROM = formModel.controls["VALIDFROM"].value;
    this.VALIDTO = formModel.controls["VALIDTO"].value;
    this.PATH = formModel.controls["PATH"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}

export var GipAdmDocPubForm = new FormGroup({
  ID: new FormControl(),
  CATEGORY: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  OBJECTID: new FormControl('', Validators.required),
  VALIDFROM: new FormControl('', Validators.required),
  VALIDTO: new FormControl('', Validators.required),
  CONTENTTYPE: new FormControl('', Validators.maxLength(255)),
  USERNAME: new FormControl('', Validators.maxLength(255)),
  REMARK: new FormControl('', Validators.maxLength(255)),
  PATH: new FormControl('', Validators.maxLength(511)),
  HINT: new FormControl(),
});

export class GipAdmDocPubModel {
  public ID: string;
  public CATEGORY: string;
  public OBJECTID: string;
  public REMARK: string;
  public CONTENTTYPE: string;
  public USERNAME: string;
  public VALIDFROM: string;
  public VALIDTO: string;
  public PATH: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CATEGORY = formModel.controls["CATEGORY"].value;
    this.OBJECTID = formModel.controls["OBJECTID"].value;
    this.REMARK = formModel.controls["REMARK"].value;
    this.CONTENTTYPE = formModel.controls["CONTENTTYPE"].value;
    this.USERNAME = formModel.controls["USERNAME"].value;
    this.VALIDFROM = formModel.controls["VALIDFROM"].value;
    this.VALIDTO = formModel.controls["VALIDTO"].value;
    this.PATH = formModel.controls["PATH"].value;
  }
  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}

export var GipAdmPropsForm = new FormGroup({
  GIP_DID: new FormControl(),
  GIP_NAME: new FormControl('', Validators.maxLength(50)),
  GIP_VALUE: new FormControl(),
  TEXT: new FormControl('', Validators.maxLength(2048)),
  LANG: new FormControl('', Validators.required),
});

export class GipAdmPropsModel {
  public GIP_DID: number;
  public GIP_NAME: string;
  public GIP_VALUE: string;
  public LANG: string;
  public TEXT: string;


  fromFormGroupModel(formModel: FormGroup) {
    this.GIP_DID = formModel.controls["GIP_DID"].value;
    this.GIP_NAME = formModel.controls["GIP_NAME"].value;
    this.GIP_VALUE = formModel.controls["GIP_VALUE"].value;
    this.LANG = formModel.controls["LANG"].value;
    this.TEXT = formModel.controls["TEXT"].value;

  }

  getUpdateMap() {
    return new Map ([
      ["GIP_DID", `${this.GIP_DID}`],
      ["LANG", `'${this.LANG}'`],
    ]);
  }
}

export var GipAdmTextForm = new FormGroup({
  APPLICATION: new FormControl(),
  TEXTID: new FormControl('', [Validators.required, Validators.maxLength(20)]),
  USERNAME: new FormControl('', Validators.maxLength(150)),
  LANG: new FormControl('', Validators.required),
  TEXT: new FormControl()
});

export class GipAdmTextModel {
  public APPLICATION: string;
  public TEXTID: string;
  public USERNAME: string;
  public LANG: string;
  public TEXT: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.APPLICATION = formModel.controls["APPLICATION"].value;
    this.TEXTID = formModel.controls["TEXTID"].value;
    this.USERNAME = formModel.controls["USERNAME"].value;
    this.LANG = formModel.controls["LANG"].value;
    this.TEXT = formModel.controls["TEXT"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["APPLICATION", `'${this.APPLICATION}'`],
      ['TEXTID', `'${this.TEXTID}'`],
      ['LANG', `'${this.LANG}'`],
    
    ]);
  }
}